export default __webpack_public_path__ + "static/media/IconDesc_PackagedAluminaSolution.256.d4c1bcca.png";